import axios from "axios";
import { uri } from "../help/Api";
import { sto } from "../Context/InshData";

export const GROUPS_URL = uri + "Groups";
export const defaultDG = {
  id: "",
  name: "",
  nameEN: "",
  group_id: "",
  parent_id: 0,
  type: "main",
  printer: "",
  group_Emps: [],
  parent: { id: 0, name: "" },
  color: -1,
};

export function list() {
  return axios.get(GROUPS_URL);
}

export function create(data) {
  return axios.post(GROUPS_URL, data);
}

export function update(data) {
  return axios.put(GROUPS_URL, data);
}
export function remove(id) {
  let Urls = null;
  if (sto.db_name === "" || sto.db_name === null) {
    Urls = `Groups?id=${id}`
  } else {
    Urls = `Groups?id=${id}&&db_name=${sto?.db_name}`
  }
  return axios.delete(uri + Urls);
}

export default { list, create, update, remove };
